import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, browserHistory, Redirect } from "react-router-dom";

// Styles
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "../scss/style.scss";
// Temp fix for reactstrap
import "../scss/core/_dropdown-menu-right.scss";
import "react-notifications/lib/notifications.css";
import Proptypes from "prop-types";

//Styles for the dropzone component
import "../node_modules/react-dropzone-component/styles/filepicker.css";
import "../node_modules/dropzone/dist/min/dropzone.min.css";

// Containers
import Full from "./containers/Full/";
import { Provider } from "react-redux";
import { NotificationContainer } from "react-notifications";

// Views
import Login from "./views/Pages/Login/";
import SSO from "./views/Pages/SSO/";
import Connect from "./views/Connect";
import Page404 from "./views/Pages/Page404/";
import Page500 from "./views/Pages/Page500/";
import store from "./store";
import Go from "./views/Go/";

import UserDashboard from "./views/User/UserDashboard";

require("es6-promise").polyfill();
require("isomorphic-fetch");

function loggedIn() {
    if(JSON.parse(window.localStorage.getItem("user_info")).token != null 
      && JSON.parse(window.localStorage.getItem("user_info")).token != undefined)
    {
        return true;
    }
    return false;
}

function requireAuth() {
    if (!loggedIn()) {
        return true;
    }
    else {
        return false;
    }
}


// In some instances either the username or token my get removed from the local storage user_info structure
//  This function ensures they are set. Callers may use this function to determine if the user is in a proper state
//  else the login page will be rendered.

function validUserInfo(user_info, rest){
    if (user_info) {
        try {
            let parsed_user_info = user_info;
            if (typeof user_info === 'string') {
                parsed_user_info = JSON.parse(user_info)
            }
            if (parsed_user_info.username && parsed_user_info.token) {
                return true;
            }
        }
        catch (err){
            console.error("Error parsing user_info." + err)
        }
    }
    return false;
}

function PrivateRoute ({component: Component, ...rest}) {
    const user_info = window.localStorage.getItem("user_info");
    return (
        <Route
            {...rest}
            render={(props) => validUserInfo(user_info, rest)
                ? <Component {...props} />
                : <Redirect to={{pathname: "/login", state: {from: props.location}}} />}
        />
    );
}

ReactDOM.render((
    <div>
    <NotificationContainer/>
    <Provider store={store} history={browserHistory}>
        <HashRouter>
            <Switch>
                <Route exact path="/login" name="Login Page" render={() => (
                    validUserInfo(window.localStorage.getItem("user_info")) ? (
                        <Redirect to="/"/>
                    ) : (
                        <Login/>
                    )
                )}/>
                <Route onEnter={requireAuth} exact path="/login" name="Login Page" component={Login}/>
                <Route onEnter={requireAuth} exact path="/staticlogin" name="Login Page" component={Login}/>
                <Route exact path="/sso/:user_id/:session_token" name="SSO" component={SSO}/>
                <Route exact path="/connect/:type/:kasm_id/:user_id/:session_token" name="Connect" component={Connect}/>
                <Route exact path="/404" name="Page 404" component={Page404}/>
                <Route exact path="/500" name="Page 500" component={Page500}/>
                <PrivateRoute authed={requireAuth} exact path="/go" name="Go" component={Go} />
                <PrivateRoute authed={requireAuth} path="/" name="Home" component={Full} />
            </Switch>
        </HashRouter>
    </Provider>
    </div>
), document.getElementById("root"));

PrivateRoute.propTypes = {
    location: Proptypes.object,
    component: Proptypes.func
};



// WEBPACK FOOTER //
// ./src/index.js